import { createContext } from "react";

export const LoanInputContext = createContext(null);